var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticClass:"d-block",attrs:{"value":_vm.selected,"placeholder":_vm.plc ||  _vm.$t('message.region'),"filterable":"","clearable":"","size":_vm.size},on:{"input":_vm.dispatch}},_vm._l((_vm.regions),function(region){return _c('el-option',{key:region.id,attrs:{"label":region.name,"value":region.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }